//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    apiUrl,
    apiParams
} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

import amapLocation from "@/components/amap/amapLocation.vue"

export default {
    name: 'DeliveImgLading',
    components: {
        MyBtnReturn,
        amapLocation
    },
    data() {
        return {
            src1: require('@/assets/images/plan/wx_zhuang_blue.png'), // 装箱的icon图片
            src2: require('@/assets/images/wx_song_green.png'), // 送货的icon图片

            check: require('@/assets/images/ic_check.png'),
            unCheck: require('@/assets/images/ic_unCheck.png'),

            bookingId: '',
            ladingId: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            // src2: require('@/assets/images/wx_song_green.png'), // 送货的icon图片
            tableData: [],
            address: null,

            isShowTable: true,
            isShowLoading: false,
            isNoData: false,

            showBottomHandel: false,
            location: null
        }
    },
    watch: {
        location(newValue, oldValue) {
            this.address = newValue.address
        }
    },
    created() {
        document.title = '更新位置';
        this.bookingId = this.$route.query.bookingId;
        this.ladingId = this.$route.query.ladingId;
        this.servicetype = this.$route.query.servicetype;
        this.getData();
    },
    methods: {
        getData() {
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                bookingId: this.bookingId
            };
            this.showBottomHandel = false;
            this.address = null;
            this.isShowLoading = true;
            this.requestApi({
                url: apiUrl.getLocationNoticeDetail,
                data: data
            }, (resultData) => {
                this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                // 一个工作单有多个柜号id(即多条柜)，因此sonos是数组，这里应该不会出现空数组的情况

                let sonos = resultData.data || [];

                this.tableData = sonos.map(item => {
                    return {
                        ...item,
                        check: false
                    }
                })

            }, (error) => {
                this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            })
        },
        checkItem(index) {
            this.tableData[index].check = !this.tableData[index].check;
            this.showBottomHandel = false;
            this.tableData.forEach(item => {
                if (item.check) {
                    this.showBottomHandel = true
                }
            })
        },
        upload() {
            if (!this.address) {
                this.showToast('请输入位置');
                return
            }
            let ids = this.tableData.map(item => {
                if (item.check) {
                    return item.id
                }
            });
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                ids: ids.join(','),
                location: this.address
            };
            this.$http.post(apiUrl.locationNoticeSave, data)
                .then((response) => {
                    if (response.data.code == 200) {
                        this.getData()
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/siji/locationUpdate/LocationUpload.vue